import { useState } from "react";
import { Row, Col, Card, Modal, Button, Stack } from "react-bootstrap";
import AdminModuloTarjeta from "../jefatura/AdminModuloTarjeta";
import CrearModuloModal from "../jefatura/CrearModuloModal";
import EditarModuloModal from "../jefatura/EditarModuloModal";
import EliminarModuloModal from "../jefatura/EliminarModuloModal";
import AdministrarMotivosModal from "../jefatura/AdministrarMotivosModal";

function AdminModulosDisplay({
  modulos = [],
  onModulosChanged,
  onMotivosChanged,
}) {
  const [showModal, setShowModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const [moduloEditando, setModuloEditando] = useState(null);
  const [showEditModal, setShowEditModal] = useState(false);
  const [confirmDesactivar, setConfirmDesactivar] = useState(null);
  const [confirmEliminar, setConfirmEliminar] = useState(null);
  const [showMotivosModal, setShowMotivosModal] = useState(false);

  const handleOpenEdit = (modulo) => {
    setModuloEditando(modulo);
    setShowEditModal(true);
  };

  const handleCloseEdit = () => {
    setModuloEditando(null);
    setShowEditModal(false);
  };

  const handleConfirmDesactivar = (data) => {
    setConfirmDesactivar(data);
  };

  const handleCancelDesactivar = () => {
    setConfirmDesactivar(null);
  };

  const handleConfirmarDesactivar = () => {
    if (confirmDesactivar?.onConfirm) {
      confirmDesactivar.onConfirm();
    }
    setConfirmDesactivar(null);
  };

  const handleConfirmEliminar = (data) => {
    setConfirmEliminar(data);
  };

  const handleCancelEliminar = () => {
    setConfirmEliminar(null);
  };

  const handleConfirmarEliminar = () => {
    if (confirmEliminar?.onConfirm) {
      confirmEliminar.onConfirm();
    }
    setConfirmEliminar(null);
  };

  const handleOpenModal = () => setShowModal(true);
  const handleCloseModal = () => setShowModal(false);

  // const handleOpenMotivosModal = () => setShowMotivosModal(true);
  // const handleCloseMotivosModal = () => setShowMotivosModal(false);

  const handleCreateModulo = async (nuevoModulo) => {
    console.log("Nuevo módulo creado:", nuevoMeson);
    setShowModal(false);
    onModulosChanged?.();
  };

  return (
    <>
      <Card className="p-4 shadow-sm border">
        <Row className="mb-4 d-flex align-items-center g-2">
          <Col xs="auto">
            <p className="h3 mb-0">Administración de Módulos</p>
          </Col>

          {/* El truco: este Col auto se empuja a la derecha */}
          <Col xs="auto" className="ms-auto">
            <button
              className="btn-accent btn fw-semibold text-white"
              onClick={handleOpenModal}
              disabled={loading}
            >
              {loading ? "Creando..." : "Crear Módulo"}
            </button>
          </Col>
        </Row>

        {modulos.length === 0 ? (
          <p className="text-muted">No hay módulos disponibles.</p>
        ) : (
          <Row className="g-3">
            {modulos
              .slice()
              .sort((a, b) => a.nombre.localeCompare(b.nombre)) // orden alfabético
              .map((m) => (
                <Col key={m.id} xs={12} md={4}>
                  <AdminModuloTarjeta
                    id={m.id}
                    nombre={m.nombre}
                    numero={m.numero}
                    estado={m.estado}
                    funcionario={m.funcionario}
                    motivos={m.motivos}
                    onEdit={() => handleOpenEdit(m)}
                    onModulosChanged={onModulosChanged}
                    onConfirmDesactivar={handleConfirmDesactivar}
                  />
                </Col>
              ))}
          </Row>
        )}

        <CrearModuloModal
          show={showModal}
          onClose={handleCloseModal}
          onCreate={handleCreateModulo}
          onModulosChanged={onModulosChanged}
        />
      </Card>

      {/* Modal de edición */}
      {moduloEditando && (
        <EditarModuloModal
          show={showEditModal}
          onClose={handleCloseEdit}
          modulo={moduloEditando}
          onModulosChanged={onModulosChanged}
          onConfirmEliminar={handleConfirmEliminar}
        />
      )}

      {/* Modal de confirmación para desactivar módulo */}
      <Modal show={!!confirmDesactivar} onHide={handleCancelDesactivar}>
        <Modal.Header closeButton>
          <Modal.Title>Confirmar desactivación</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          ¿Estás seguro que deseas desactivar el módulo{" "}
          <strong>{confirmDesactivar?.nombre}</strong>?
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleCancelDesactivar}>
            Cancelar
          </Button>
          <Button variant="danger" onClick={handleConfirmarDesactivar}>
            Sí, desactivar
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Modal de confirmación para eliminar módulo */}
      <EliminarModuloModal
        show={!!confirmEliminar}
        onClose={handleCancelEliminar}
        onConfirm={handleConfirmarEliminar}
        nombreModulo={confirmEliminar?.nombre}
      />

      {/* Modal de administración de motivos */}
      {/* <AdministrarMotivosModal
      show={showMotivosModal}
      onClose={handleCloseMotivosModal}
      onMotivosChanged={() => {
        onModulosChanged?.();
        onMotivosChanged?.();
      }}
    /> */}
    </>
  );
}

export default AdminModulosDisplay;
